import { cva } from "class-variance-authority";

export const dialogPaneVariants = cva(
  [
    "flex w-full flex-col gap-6 py-6 outline-none",
    "max-h-[var(--pd-dialog-pane-max-h,74vh)]",
    "[&_[data-dialog-body]]:min-h-0 [&_[data-dialog-body]]:flex-1",
    "motion-reduce:animate-none",
  ],
  {
    variants: {
      active: {
        true: "relative z-10",
        false: "pointer-events-none absolute inset-x-0 top-0 opacity-0",
      },
      motion: {
        none: "",
        "in-from-right": "animate-dialog-pane-in-from-right",
        "in-from-left": "animate-dialog-pane-in-from-left",
        "out-to-left": "z-10 animate-dialog-pane-out-to-left",
        "out-to-right": "z-10 animate-dialog-pane-out-to-right",
      },
    },
    defaultVariants: {
      active: true,
      motion: "none",
    },
  }
);

export type DialogPaneMotion = "none" | "in-from-right" | "in-from-left" | "out-to-left" | "out-to-right";
